import React from 'react';
import { Button } from 'elements';
import { Close } from 'core/icons';
import { TextInput } from '../';
import tulkojumi from 'utils/tulkojumi';
import { InputWrapper, CloseButtonWrapper } from './styled';

class KeywordsInput extends React.PureComponent {
  state = {
    inputEmpty: !this.props.defaultValue,
  };

  _onClear = () => {
    if (!this.state.inputEmpty) {
      this.setState(prevState => Object.assign({}, prevState, {
        inputEmpty: true,
      }), () => {
        this._input.value = '';
        const { onChange } = this.props;
        onChange && onChange(null);
      });
    }
  }

  _onInputChange = (event) => {
    const empty = event.target.value.length === 0;
    if (empty !== this.state.inputEmpty) {
      this.setState(prevState => Object.assign({}, prevState, {
        inputEmpty: empty,
      }));
    }
  }

  render() {
    const {
      defaultValue,
      placeholder,
      onChange,
      teksti,
    } = this.props;

    return (
      <InputWrapper>
        <TextInput
          defaultValue={defaultValue}
          placeholder={placeholder}
          innerRef={c => this._input = c}
          onChange={this._onInputChange}
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onChange && onChange(event.target.value);
            }
          }}
        />

        <CloseButtonWrapper>
          {
            !this.state.inputEmpty && (
              <Button
                type='text'
                accent='secondary'
                a11yLabel={tulkojumi(teksti, 'dzest')}
                icon={Close}
                onClick={() => {
                  this._onClear();
                }}
              />
            )
          }
        </CloseButtonWrapper>
      </InputWrapper>
    );
  }
}

export default KeywordsInput;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/KeywordsInput/KeywordsInput.jsx